// 证件类型
export enum IDType {
    Default = -1, // 默认
    IdCard = 0, // 身份证
    Passort = 1, // 护照
}
